import { Stack, Skeleton } from '@mui/material';
import React from 'react';
const DecisionConfirmationModalShimmer = () => {
  return (
    <>
      <Stack
        id='decision-confirmation-modal-shimmer'
        data-testid='decision-confirmation-modal-shimmer'
        direction='column'
        justifyContent='space-between'
        sx={{
          height: '14.75rem',
          width: '100%',
        }}
      >
        <Skeleton
          data-testid='skeleton-2'
          variant='rectangular'
          width={59}
          animation='wave'
          height={20}
          sx={{
            bgcolor: (theme) => theme.palette.neutral?.main,
            mb: 0.3,
          }}
        />
        <Skeleton
          data-testid='skeleton-2'
          variant='rectangular'
          width={156}
          animation='wave'
          height={22}
          sx={{
            bgcolor: (theme) => theme.palette.neutral?.main,
            mb: 0.8,
          }}
        />
        <Skeleton
          data-testid='skeleton-2'
          variant='rectangular'
          width={55}
          animation='wave'
          height={20}
          sx={{
            bgcolor: (theme) => theme.palette.neutral?.main,
            mb: 0.3,
          }}
        />
        <Skeleton
          data-testid='skeleton-2'
          variant='rectangular'
          width={450}
          animation='wave'
          height={25}
          sx={{
            bgcolor: (theme) => theme.palette.neutral?.main,
            mb: 0.8,
          }}
        />
        <Skeleton
          data-testid='skeleton-2'
          variant='rectangular'
          width={800}
          animation='wave'
          height={90}
          sx={{
            bgcolor: (theme) => theme.palette.neutral?.main,
            mb: 1,
          }}
        />
      </Stack>
      <Stack
        id='decision-confirmation-modal-submit-shimmer'
        data-testid='decision-confirmation-modal-submit-shimmer'
        justifyContent='center'
        display={'flex'}
        alignItems={'center'}
        sx={{
          height: '2.75rem',
          width: '100%',
        }}
      >
        <Skeleton
          data-testid='skeleton-2'
          variant='rectangular'
          width={150}
          animation='wave'
          height={30}
          sx={{
            bgcolor: (theme) => theme.palette.neutral?.main,
            mt: 0.5,
          }}
        />
      </Stack>
    </>
  );
};

export default DecisionConfirmationModalShimmer;
